<template>
  <widget-template :scroll="false">
    <v-layout row wrap class="smallWidgetLayout" fill-height>
      <v-flex xs4 align-center justify-center d-flex>
        <v-icon color="orange" class="widgetIcon">mdi-bookmark</v-icon>
      </v-flex>
      <v-flex xs8 d-flex>
        <v-tooltip top>
          <v-layout column justify-end slot="activator">
            <v-flex class="widgetHeader" d-flex justify-end>My Quotations Issued</v-flex>
            <v-flex :class="widgetTextStyle(myQuotationsIssued.noQuote)" d-flex justify-end>
              {{animatedNumber}}
            </v-flex>
          </v-layout>
          <span>{{infoText}}</span>
        </v-tooltip>
      </v-flex>
      <v-flex xs12 class="widgetInfoPnl">
        <v-divider></v-divider>
        <v-layout row wrap class="widgetInfo grey--text" align-center>
          <v-menu offset-y>
            <div slot="activator">
              <v-tooltip top>
                <v-layout align-center slot="activator">
                  <v-icon>mdi-calendar-today</v-icon> {{selectedScope.description}}
                </v-layout>
                <span>{{formatDisplayDate(selectedScope.from)}} to {{formatDisplayDate(selectedScope.to)}}</span>
              </v-tooltip>
            </div>
            <v-list>
              <v-list-tile v-for="(option, key) in scopes" :key="key" @click="doSelectScope(key)">
                <v-list-tile-title>{{ option.description }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-spacer></v-spacer>
          <div v-if="initState === 0">
            <!-- <v-tooltip top>
              <span slot="activator">
                <v-icon small color="orange">mdi-record</v-icon>
                Loading...
              </span>
              <span>Loading</span>
            </v-tooltip> -->
          </div>
          <div v-else-if="initState === 1">
            <!-- <v-tooltip top>
              <div slot="activator" @click="doReload" class="widgetAction">
                Updated {{lastUpdated}} ago
              </div>
              <span>Click to update</span>
            </v-tooltip> -->
          </div>
          <div v-else>
            <v-tooltip top>
              <div slot="activator" @click="doReload" class="widgetAction">
                <v-icon small color="red">mdi-record</v-icon>
                Error
              </div>
              <span>Click to retry</span>
            </v-tooltip>
          </div>
        </v-layout>
      </v-flex>
    </v-layout>
  </widget-template>
</template>

<script>
import { mapActions } from 'vuex'
import { formatDisplayTimeDistance } from '@/utils/date'
import { shortScopeMixin } from '../shortScopeMixin'
import { TweenLite } from 'gsap/TweenMax'

export default {
  data() {
    return {
      tweenedNumber: 0
    }
  },
  watch: {
    'myQuotationsIssued.noQuote': function (newValue) {
      this.doAnimateNumber(newValue)
    }
  },
  computed: {
    myQuotationsIssued() {
      return this.$store.state.widgets.myQuotationsIssued
    },
    initState() {
      return this.myQuotationsIssued.init
    },
    lastUpdated() {
      return formatDisplayTimeDistance(this.myQuotationsIssued.lastUpdated, this.timeNow)
    },
    infoText() {
      let result = this.myQuotationsIssued.info + ' - ' + this.formatPermitAppIdsText(this.myQuotationsIssued.appIds)
      return result
    },
    animatedNumber() {
      return this.tweenedNumber.toFixed(0)
    }
  },
  methods: {
    ...mapActions([
      'initMyQuotationsIssued'
    ]),
    doReload() {
      this.initMyQuotationsIssued(this.scopeForm)
    },
    doAnimateNumber(newValue) {
      TweenLite.to(this.$data, 0.5, { tweenedNumber: newValue })
    }
  },
  mounted() {
    if (this.initState !== 1) {
      this.doSelectScope('today')
    } else if (this.myQuotationsIssued.scope) {
      this.doAnimateNumber(this.myQuotationsIssued.noQuote)
      this.doSelectScope(this.myQuotationsIssued.scope)
    }
  },
  mixins: [
    shortScopeMixin(true)
  ]
}
</script>

<style lang="scss" scoped>
</style>
